import { Box, Button, Stack, Heading, LightMode, SimpleGrid, Text } from '@chakra-ui/react'

export const Hero = () => {
  return (
    <Box
      as="section"
    //   bg="gray.800"
      py="12"
      position="relative"
      
      // h={{ base: '361px', md: '574px' }}
      h={['500px', '500px', '574px']}
      bgImage="/Pool71.png"
      bgSize="cover"
      bgPosition="center"
      _after={{
        content: `""`,
        display: 'block',
        w: 'full',
        h: 'full',
        // bg: 'blackAlpha.700',
        position: 'absolute',
        inset: 0,
        zIndex: 0,
      }}
    >
      <Box
        maxW={{ base: 'xl', md: '7xl' }}
        mx="auto"
        px={{ base: '6', md: '8' }}
        h="full"
        zIndex={1}
        position="relative"
      >
        <Stack flexDirection="column" textAlign="left" color="white" h="full" pl={'5%'}pr={'5%'}>
          <Heading fontFamily={'montserrat, sans-serif'} size={["l", "xl", "xl"]} fontWeight="extrabold" pt={['50%','25%','25%']}>
          Investment Properties
          </Heading>
          <Heading fontFamily={'montserrat, sans-serif'} fontSize={["16px", "25px", "27px"]} fontWeight="light" pt={'2%'} lineHeight={['25px','40px','45px']}>
          A brief summary of our business dealings, spanning from the inception of the Shin-Zylstra team to the present day.
          </Heading>
        </Stack>
      </Box>
      <Box
        display={{ base: 'none', md: 'block' }}
        position="absolute"
        zIndex={2}
        w="full"
        bottom="0"
        py="4"
        
      >
      </Box>
    </Box>
  )
}